import React from "react";

/**
 * Clean & Minimal Generic Toggle Component
 *
 * @param {Object} props
 * @param {boolean} [props.checked=false] - Whether switch is ON or OFF
 * @param {Function} [props.onChange] - Callback when clicked: (newChecked) => void
 * @param {boolean} [props.disabled=false] - Disabled state
 * @param {string} [props.size="sm"] - "sm" | "md"
 * @param {string} [props.className=""] - Additional class names
 */
export default function Toggle({
  checked = false,
  onChange,
  disabled = false,
  size = "sm",
  className = "",
}) {
  const isChecked = Boolean(checked);

  const handleClick = (e) => {
    if (e) {
      e.stopPropagation();
      e.preventDefault();
    }
    if (disabled || !onChange) return;
    onChange(!isChecked);
  };

  const isMd = size === "md";

  return (
    <button
      type="button"
      role="switch"
      aria-checked={isChecked}
      disabled={disabled}
      onClick={handleClick}
      className={`relative inline-flex items-center rounded-full transition-colors duration-200 cursor-pointer focus:outline-none swiper-no-swiping ${
        isMd ? "w-9 h-5 p-0.5" : "w-7 h-4 p-0.5"
      } ${
        isChecked
          ? "bg-emerald-500 hover:bg-emerald-600"
          : "bg-slate-300 hover:bg-slate-400"
      } ${disabled ? "opacity-50 cursor-not-allowed" : ""} ${className}`}
    >
      <span
        className={`pointer-events-none inline-block rounded-full bg-white shadow-sm transform transition duration-200 ease-in-out ${
          isMd ? "w-4 h-4" : "w-3 h-3"
        } ${isChecked ? (isMd ? "translate-x-4" : "translate-x-3") : "translate-x-0"}`}
      />
    </button>
  );
}
